/* eslint-disable better-mutation/no-mutation */

import LookupPersonalNumber from '../../../services/lookup-personal-number';
import formatPersonalId from '../format-personal-id';
import { isServer } from 'tradera/utils/nextjs';

if (isServer) {
    // Do not remove this without also removing the disable of eslint better-mutation/no-mutation at top of file.
    throw new Error(
        'This implementation is not compatible with SSR as global properties are shared between server instances'
    );
}

export default class PersonalDetailsAutoFill {
    constructor() {
        this.onValidation = this.onValidation.bind(this);
        this.autoFilledValue = null;
    }

    onValidation(form, field) {
        const fieldState = form.fields[field];
        if (field !== 'PersonalNumber') {
            return;
        }
        if (!fieldState.isValid) {
            this.clearPersonalDetails(form);
            return;
        }
        const formattedValue = formatPersonalId(fieldState.value);

        if (this.autoFilledValue === formattedValue) {
            return;
        }
        this.autoFilledValue = formattedValue;
        this.lookupPersonalDetails(form, formattedValue);
    }

    lookupPersonalDetails(form, personalNumber) {
        LookupPersonalNumber(personalNumber)
            .then((result) => {
                if (result.hasDetails) {
                    form.setFromGenerated('AutoPersonalDetails', true);
                    form.update((f) => {
                        f.autoFillFailed = false;
                    });
                } else {
                    form.update((f) => {
                        f.autoFillFailed = true;
                    });
                }
                return;
            })
            .catch(() => {
                form.update((f) => {
                    f.autoFillFailed = true;
                });
            });
    }

    clearPersonalDetails(form) {
        this.autoFilledValue = null;
        PersonalDetailsAutoFill.autoFilledFields.forEach((f) => form.remove(f));
    }
}

PersonalDetailsAutoFill.autoFilledFields = ['AutoPersonalDetails'];

PersonalDetailsAutoFill.manuallyFilledFields = [
    'FirstName',
    'LastName',
    'StreetName',
    'Town',
    'ZipCode'
];
